var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-menu-bar',[_c('b-navbar-nav',_vm._l((_vm.routes),function(route){return _c('router-link',{key:route.name,staticClass:"nav-link",attrs:{"id":route.name+'-main-link',"to":route.path ? route.path : '/'}},[_vm._v(_vm._s(route.label))])}),1),_vm._v(" "),_c('user-menu',{staticClass:"ml-auto"},[_c('b-dropdown-item',{attrs:{"href":"/guide/me"}},[_vm._v("Minha Conta")]),_vm._v(" "),_c('b-dropdown-divider')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c54d6986","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/main-menu/MainMenu.vue
// module id = 874
// module chunks = 0